module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon.ico
// module id = 2467
// module chunks = 84